import { Link } from "react-router-dom";
import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";

export default function TermsAcceptance({ values, onChange, errors = {} }) {
  const items = [
    {
      key: "acceptTerms",
      label: (
        <>
          I accept the{" "}
          <Link to="/terms" target="_blank" className="text-primary hover:underline font-medium">
            Terms of Service
          </Link>
        </>
      ),
    },
    {
      key: "acceptPrivacy",
      label: (
        <>
          I accept the{" "}
          <Link to="/privacy" target="_blank" className="text-primary hover:underline font-medium">
            Privacy Policy
          </Link>
        </>
      ),
    },
    {
      key: "acceptCookies",
      label: (
        <>
          I accept the{" "}
          <Link to="/cookie-policy" target="_blank" className="text-primary hover:underline font-medium">
            Cookie Policy
          </Link>
        </>
      ),
    },
  ];

  return (
    <div className="space-y-3 rounded-xl border border-border/60 bg-muted/30 p-4">
      <p className="text-sm font-medium text-foreground">Legal agreements</p>
      {items.map(({ key, label }) => (
        <div key={key} className="flex items-start gap-3">
          <Checkbox
            id={key}
            checked={!!values[key]}
            onCheckedChange={(checked) => onChange(key, checked === true)}
            className="mt-0.5"
          />
          <Label htmlFor={key} className="text-sm leading-relaxed font-normal cursor-pointer">
            {label}
          </Label>
        </div>
      ))}
      {(errors.acceptTerms || errors.acceptPrivacy || errors.acceptCookies) && (
        <p className="text-sm text-destructive">
          {errors.acceptTerms || errors.acceptPrivacy || errors.acceptCookies}
        </p>
      )}
    </div>
  );
}

export function validateTermsAcceptance(values) {
  const errors = {};
  if (!values.acceptTerms) errors.acceptTerms = "You must accept the Terms of Service";
  if (!values.acceptPrivacy) errors.acceptPrivacy = "You must accept the Privacy Policy";
  if (!values.acceptCookies) errors.acceptCookies = "You must accept the Cookie Policy";
  return errors;
}

export function allTermsAccepted(values) {
  return values.acceptTerms && values.acceptPrivacy && values.acceptCookies;
}
